export enum ProcurementStatusEnum {
    INQUIRY = 'inquiry',
    // ORDER_CONFIRMATION = 'order_confirmation',
    PROCURED = 'procured'
}